import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Subject {
  name: string;
}

export function useSubjects() {
  return useQuery({
    queryKey: ['document-subjects'],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .schema('document')
        .from('subjects')
        .select('name')
        .order('name');
      
      if (error) throw error;
      return data as Subject[];
    }
  });
}
